import React from "react";
import NMapFileUpload from "./NmapFileUpload";
import NetSpaceSummary from "./NetSpaceSummary";
import "./NetSpace.scss";
import { Grid } from "material-ui-core";
import Page_Loader from "../../assets/vizr_images/page_loader.gif";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import EditIcon from "@material-ui/icons/Edit";
import {
  SET_NETSPACE_SNACKBAR,
  SET_FILE_EDITABLE,
  FETCH_FILE_STATUS_CANCEL,
  SET_RELOAD_NETSPACE,
  GET_ACTIVE_NETMAP,
  GET_NETMAP_STATUS,
} from "./NetSpaceConstant";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ControlPanel from "./ControlPanel";
import NetSpaceDrawer from "./NetSpaceDrawer";
import TextField from "@material-ui/core/TextField";
import CloseIcon from "@material-ui/icons/Close";
import { Typography, CircularProgress, Box } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import { Stack } from "@mui/material";
import DescriptionIcon from "@material-ui/icons/Description";

const NetSpace = () => {
  const dispatch = useDispatch();
  // const [isEditable, setIsEditable] = useState(false);
  const [showNmapPanel, setShowNmapPanel] = useState(false);
  const loader = useSelector((state) => state.NetspaceReducer.loader);
  const isEditable = useSelector(
    (state) => state.NetspaceReducer.isFileEditable,
  );
  const snackBarMessage = useSelector(
    (state) => state.NetspaceReducer.snackBarMessage,
  );
  const snackBar = useSelector((state) => state.NetspaceReducer.snackBar);
  const nmapProgress = useSelector(
    (state) => state.NetspaceReducer.nmapProgressData,
  );
  const activeNetMap = useSelector(
    (state) => state.NetspaceReducer.activeNetMap,
  );
  const reloadNetspace = useSelector(
    (state) => state.NetspaceReducer.reloadNetspace,
  );
  const [openError, setopenError] = useState(false);
  const [errorMessage, setErrorMesage] = useState("");
  const [runName, setRunName] = useState("");
  const [networkName, setNetworkName] = useState("");

  useEffect(() => {
    dispatch({
      type: GET_ACTIVE_NETMAP,
    });
    dispatch({
      type: GET_NETMAP_STATUS,
    });
    return () => {
      dispatch({
        type: FETCH_FILE_STATUS_CANCEL,
      });
    };
  }, []);

  useEffect(() => {
    setRunName(nmapProgress?.runName);
    setNetworkName(nmapProgress?.networkName);
  }, [nmapProgress]);

  useEffect(() => {
    setopenError(snackBar);
    setErrorMesage(snackBarMessage);
  }, [snackBar]);

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setopenError(false);
    dispatch({
      type: SET_NETSPACE_SNACKBAR,
      payload: { status: false, message: "" },
    });
  };

  const handleEditClick = (bool) => {
    dispatch({
      type: FETCH_FILE_STATUS_CANCEL,
    });
    dispatch({
      type: SET_FILE_EDITABLE,
      payload: bool,
    });
  };

  const reloadPage = () => {
    dispatch({
      type: SET_RELOAD_NETSPACE,
      payload: false,
    });
    window.location.reload();
  };

  function getProcessingTimeMessage(fileSizeInBytes) {
    const baseSize = 4231675; // bytes
    const baseTime = 45; // seconds
    const estimatedTime = (fileSizeInBytes / baseSize) * baseTime;
    const minutes = Math.floor(estimatedTime / 60);
    const seconds = Math.ceil(estimatedTime % 60);
    if (minutes > 0) {
      return `Estimated time: ${minutes} minute(s) and ${seconds} second(s)`;
    } else {
      return `Estimated time: ${seconds} second(s)`;
    }
  }

  const renderStatus = () => {
    const status = nmapProgress?.status?.code;
    if (status === "UPLOADED") {
      return (
        <Box display="flex" alignItems="center">
          <CheckCircleIcon className="color-green" style={{ color: "green" }} />
          <Typography variant="body1" className="mrg-left-8">
            Uploaded {getProcessingTimeMessage(nmapProgress?.size || 0)}
          </Typography>
        </Box>
      );
    } else if (status === "INPROGRESS") {
      return (
        <Box display="flex" alignItems="center">
          <CircularProgress size={24} />
          <Typography variant="body1" className="mrg-left-8">
            In Progress {getProcessingTimeMessage(nmapProgress?.size || 0)}
          </Typography>
        </Box>
      );
    } else if (status === "PROCESSED") {
      return (
        <Box display="flex" alignItems="center">
          <CheckCircleIcon className="color-green" />
          <Typography variant="body1" className="mrg-left-8">
            Processed
          </Typography>
        </Box>
      );
    } else if (status === "ERROR") {
      return (
        <Box display="flex" alignItems="center">
          <ErrorIcon className="color-red" />
          <Typography variant="body1" className="mrg-left-8">
            Error
          </Typography>
        </Box>
      );
    } else {
      return null;
    }
  };

  const PaperComponent = (props) => {
    return <Paper {...props} />;
  };

  const renderReloadDialog = () => {
    if (reloadNetspace) {
      return (
        <Dialog
          open={reloadNetspace}
          onClose={reloadPage}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle id="draggable-dialog-title">Reload</DialogTitle>
          <DialogContent>
            <DialogContentText color="black">
              N-map file processing is completed. Please reload the page to view
              the changes.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={reloadPage} color="primary">
              Reload
            </Button>
          </DialogActions>
        </Dialog>
      );
    }
    return null;
  };

  const renderSnackBar = () => {
    return (
      <Snackbar
        open={openError}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        className="error-snackbar"
      >
        <Alert onClose={handleSnackbarClose} severity="error">
          {errorMessage}
        </Alert>
      </Snackbar>
    );
  };
  return (
    <div className="main netspace-wrapper">
      <NetSpaceDrawer />
      {loader && (
        <img
          src={Page_Loader}
          alt="loading"
          className="loader-data-source tenantProfileLoader"
        ></img>
      )}
      <div className="netspace-header">
        <div className="header-row">
          <div className="title">NetSpace</div>

          <div className="right-section">
            <div className="nmap-wrapper">
              {/* EXPANDING PANEL */}
              <div className={`nmap-panel ${showNmapPanel ? "open" : ""}`}>
                {/* Text Fields */}
                <Paper elevation={0} className="nmap-item">
                  <div className="form-row">
                    <div className="form-col">
                      <TextField
                        label="Network Name"
                        variant="outlined"
                        size="small"
                        fullWidth
                        disabled={!isEditable}
                        value={networkName}
                        onChange={(e) => setNetworkName(e.target.value)}
                      />
                    </div>

                    <div className="form-col">
                      <TextField
                        label="Run Name"
                        variant="outlined"
                        size="small"
                        fullWidth
                        disabled={!isEditable}
                        value={runName}
                        onChange={(e) => setRunName(e.target.value)}
                      />
                    </div>
                  </div>
                </Paper>

                {/* Status / Upload */}
                <div className="nmap-item">
                  {!isEditable ? (
                    renderStatus()
                  ) : (
                    <NMapFileUpload
                      runName={runName}
                      networkName={networkName}
                    />
                  )}
                </div>

                {/* Edit Icon */}
                <div className="nmap-item">
                  <EditIcon
                    onClick={() => handleEditClick(!isEditable)}
                    className="edit-nmap"
                  />
                </div>
              </div>

              {/* Trigger / Close */}
              <div className="nmap-icon-container">
                {showNmapPanel ? (
                  <CloseIcon
                    className="nmap-icon"
                    onClick={() => setShowNmapPanel(false)}
                  />
                ) : (
                  <div
                    className="nmap-trigger"
                    onClick={() => setShowNmapPanel(true)}
                  >
                    <DescriptionIcon />
                    <span>NMap</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="netspace-body">
        <NetSpaceSummary />
        <ControlPanel />
      </div>
      {renderReloadDialog()}
      {renderSnackBar()}
    </div>
  );
};

export default NetSpace;
